import * as yup from "yup";
export const EmployeeLeaveSchema = yup.object().shape({
  leaveDate: yup.date(),
  leaveType: yup.string(),
  leaveReason: yup.string(),
  leaveStatus: yup.string(),
  leaveStartDate: yup.date(),
  leaveEndDate: yup.date(),
  leaveReasonType: yup.string(),
});

export const EmployeeLeaveNewSchema = yup.object().shape({
  leaveType: yup.string().required("Leave type is required"),

  leaveDate: yup.date().when("leaveType", {
    is: (val) => val === "half day" || val === "full day",
    then: (s) => s.required("Leave date is required"),
  }),

  halfDayType: yup.string().when("leaveType", {
    is: (val) => val === "half day",
    then: (s) => s.required("Half day type is required"),
  }),

  leaveStartDate: yup.date().when("leaveType", {
    is: (val) => val === "multiple days",
    then: (s) => s.required("Start date is required"),
  }),

  leaveEndDate: yup.date().when("leaveType", {
    is: (val) => val === "multiple days",
    then: (s) => s.required("End date is required"),
  }),

  leaveReasonType: yup.string().required("Leave reason type is required"),

  leaveReason: yup.string().required("Leave reason is required"),
  supportingDocument: yup.mixed(),

  leaveStatus: yup.string(),
});
